import { render, staticRenderFns } from "./report-nav.vue?vue&type=template&id=66ca7fc9"
import script from "./report-nav.vue?vue&type=script&lang=js"
export * from "./report-nav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports